import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

type Props = {
  value?: any;
  onChange?: (value: any) => void;
  readOnly?: boolean;
};
const HTMLEditor = ({ value, onChange, readOnly }: Props) => {
  if (readOnly) {
    return <HtmlView dangerouslySetInnerHTML={{ __html: value }} />;
  }
  return (
    <QuillStyled theme="snow" value={value} onChange={onChange} />
  );
};

export default HTMLEditor;
const QuillStyled = styled(ReactQuill)`&.quill {
  align-self: stretch;
  background: #fff;
  zoom: 2;
  .ql-container.ql-snow .ql-editor {
    min-height: 15vh;
  }
}`;

const HtmlView = styled.div`
  zoom: 1.1;
  ol {
    margin: 0;
  }
`;